import React, { useState, useEffect } from 'react';
import { Modal, Button, Image } from 'react-bootstrap';
import { getRolesById } from 'pages/AccessManagement/actions';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { getFormatedDateTime } from 'utils/general';
import { createUseStyles } from 'react-jss';
import AccessRights from 'utils/AccessRights';

const useStyles = createUseStyles({
  visibleModal: {
    '& .modal-content': {
      width: '477px',
      height: '360px',
      margin: '0 auto',
    },
  },
  modalCloseBtn: {
    position: 'absolute',
    top: '15px',
    right: '13px',
  },
});

const RolesViewModal = ({ onHide, ...props }) => {
  const classes = useStyles();
  const session = useSelector(state => state.session);
  const rolesState = useSelector(state => state.rolesState);
  const dispatch = useDispatch();
  const [rolesData, setRolesData] = useState([]);

  useEffect(() => {
    if (rolesState.rolesRecord) {
      setRolesData(rolesState.rolesRecord);
    }
  }, [rolesState.rolesRecord]);

  const showUpdateForm = (recordId) => {
    dispatch(getRolesById(recordId, 'update'));
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className={classes.visibleModal}
    >
      <Modal.Header className="d-flex justify-content-between ">
        <Modal.Title id="contained-modal-title-vcenter" className="heading-color font-20 font-weight-s-bold">
          Details
        </Modal.Title>
        <Button onClick={onHide} variant="none" className={`border-0 ${classes.modalCloseBtn}`}>
          <Image src="/assets/images/close-circle.svg" />
        </Button>
      </Modal.Header>
      <Modal.Body className="border-bottom-0">
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium heading-color mb-0">Roles Name</p>
          <p className="font-13 font-weight-normal text-color mb-0">{rolesData.name}</p>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium heading-color mb-0">Created By</p>
          <p className="font-13 font-weight-normal text-color mb-0">
            {!isEmpty(rolesData.created_by_user) ? rolesData.created_by_user.name : ''}
          </p>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium heading-color mb-0">Created At</p>
          <p className="font-13 font-weight-normal text-color mb-0">
            {getFormatedDateTime(rolesData.date_created)}
          </p>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium heading-color mb-0">Last Updated By</p>
          <p className="font-13 font-weight-normal text-color mb-0">
            {!isEmpty(rolesData.updated_by_user) ? rolesData.updated_by_user.name : ''}
          </p>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium heading-color mb-0">Last Updated At</p>
          <p className="font-13 font-weight-normal text-color mb-0">
            {getFormatedDateTime(rolesData.date_last_modified)}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0 justify-content-center gap-4">
        {AccessRights(session.current_page_permissions, 'edit', rolesData.created_by) &&
        rolesData.is_deleted === 'n' ? (
          <button variant="none" className="n-u-btn" onClick={() => showUpdateForm(rolesData.id)}>
            <Image src="/assets/images/edit-white.svg" className="me-2 text-white" />
            Update
          </button>
        ) : null}
        <button variant="none" className="c-b-btn" onClick={onHide}>
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default RolesViewModal;
